const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";
// const API_URL = "http://localhost:5000";
// Default to true if env is missing
const DEBUG_MODE = process.env.REACT_APP_DEBUG !== "false";// Convert string to boolean
// Add maintenance mode configuration
const MAINTENANCE_MODE = false;

// Only disable info logs in production, but keep error logs
if (!DEBUG_MODE) {
    console.log = () => {}; // Disable info logs in production
    console.warn = () => {};
    // Keep console.error for critical errors
}
export { API_URL, DEBUG_MODE, MAINTENANCE_MODE };
